import Component from '_core_ext/components/Component';

const EXPANDED_CLASS = 'expanded';
const HIDDEN_CLASS = 'hidden';

export default class Expandable extends Component {
    static get selector() {
        return '.js-expandable';
    }

    init(...args) {
        super.init(args);
        this.onToggle = this.onToggle.bind(this);
        this.event('click', '.js-toggler', this.onToggle);
        this.$expandableList = this.$el.find('.imagery-expandable');

        if (this.config.isExpanded) {
            this.$el.addClass(EXPANDED_CLASS);
            this.$expandableList.removeClass(HIDDEN_CLASS);
        } else {
            this.$expandableList.addClass(HIDDEN_CLASS);
        }
    }

    onToggle() {
        this.$el.toggleClass(EXPANDED_CLASS);

        this.$expandableList.toggleClass(HIDDEN_CLASS);

        const $toggler = $(event.target).closest('.js-toggler');

        if ($toggler.length && $toggler.is('[aria-selected]')) {
            const isExpanded = this.$el.hasClass(EXPANDED_CLASS);
            $toggler.attr('aria-selected', isExpanded ? 'true' : 'false');
        }
    }
}

module.exports = Expandable;
